<template>
  <div ref="dom" class="charts chart-bar"></div>
</template>

<script>
import * as echarts from "echarts";
import { on, off } from "@/libs/tools";
export default {
  name: "ChartBar",
  props: {
    value: Array,
    text: String,
    subtext: String,
  },
  data() {
    return {
      dom: null,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        // console.log(newVal);
        this.loadEcharts(newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    resize() {
      this.dom.resize();
    },
    loadEcharts(val) {
      this.$nextTick(() => {
        let xAxisData = val.map((item) => item.collegeName);
        let seriesData = val.map((item) => item.exchangeNum);
        let option = {
          // color:["#16d0c8","#ff5b82","#ffba00","#6967f4"],
          grid: {
            left: "3%",
            right: "3%",
            top: "10%",
            bottom: "6%",
            containLabel: true,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            show: true,
            icon: "circle",
            top: "0",
            right: "3%",
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: true,
              show: true,
              axisTick: {
                show: false,
              },
              splitLine: {
                show: false,
                lineStyle: {
                  // type: "dashed",
                  // 使用深浅的间隔色
                  color: "#f1f3f8",
                },
              },
              // axisLabel: {
              //   fontSize: 12,
              //   color: "#666",
              //   rotate: 30,
              // },
              axisLabel: {
                fontSize: 14,
                color: "#666",
                // margin: 8,
                formatter: function (value) {
                  var str = "";
                  var num = 4; //每行显示字数
                  var valLength = value.length; //该项x轴字数
                  var rowNum = Math.ceil(valLength / num); // 行数

                  if (rowNum > 1) {
                    for (var i = 0; i < rowNum; i++) {
                      var temp = "";
                      var start = i * num;
                      var end = start + num;

                      temp = value.substring(start, end) + "\n";
                      str += temp;
                    }
                    return str;
                  } else {
                    return value;
                  }
                },
              },
              axisLine: {
                lineStyle: {
                  type: "solid",
                  color: "#f1f3f8", //左边线的颜色
                  width: "1", //坐标线的宽度
                },
              },
              data: xAxisData,
            },
          ],
          yAxis: [
            {
              name: "人数",
              type: "value",
              scale: true,
              name: "",
              axisLine: {
                show: true,
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#f1f3f8",
                },
              },
              axisLabel: {
                fontSize: 14,
                color: "#666",
              },
              axisLine: {
                lineStyle: {
                  color: "#277d95",
                  width: 1,
                },
              },
              min: 0,
            },
          ],
          series: [
            // {
            //   name: "预计招生人数",
            //   type: "bar",
            //   //   barGap: 10,
            //   itemStyle: {
            //     color: "#76bdff",
            //     // borderRadius: [6, 6, 6, 6],
            //   },
            //   barWidth: "12%",
            //   yAxisIndex: 0,
            //   data: seriesData01,
            // },
            {
              name: "专业调整人数",
              type: "bar",
              //   barGap: 0,
              itemStyle: {
                color: "#30ded6",
                // borderRadius: [6, 6, 6, 6],
              },
              label: {
                show: true,
                position: "top",
              },
              barWidth: "20%",
              yAxisIndex: 0,
              data: seriesData,
            },
          ],
        };
        if (this.dom != null && this.dom != "" && this.dom != undefined) {
          this.dom.dispose();
        }
        this.dom = echarts.init(this.$refs.dom);
        this.dom.setOption(option);
        on(window, "resize", this.resize);
      });
    },
  },

  beforeDestroy() {
    off(window, "resize", this.resize);
  },
};
</script>
